import React from 'react'
import { Collection, WhenCollectionIsNotEmpty } from '@morningtrain/react-resources'
import { EnumFilter, SearchFilter, SelectedDepartmentFilter } from 'support/filters'
import * as UI from 'ui'
import { Translation, Translator } from '@morningtrain/react-translations'
import { Can } from '@morningtrain/react-auth'
import Permissions from 'services/Permissions'
import AdminPageWithSmartview from 'pages/app/AdminPageWithSmartview'
import OnboardingListView from './partials/OnboardingListview'
import { Link } from '@morningtrain/react-navigation'
import TranslatedTitle from 'widgets/TranslatedTitle'
import { PaginationFilter } from '@morningtrain/react-filters'

export default function OnboardingChecklist () {
  return (
    <AdminPageWithSmartview>
      <Translator namespace='onboarding'>

        <UI.PageHeader title={<TranslatedTitle name='titles.overview' />}>
          <UI.ButtonWrap>
            <Can permission={Permissions.ONBOARDING_CHECKLIST_TEMPLATES_MANAGE}>
              <Link route='app.onboarding.templates'>
                <UI.Button>
                  <UI.WithIcon size={5} placement='right' icon={<UI.Icons.Settings />}>
                    <Translation name='actions.manage_templates' />
                  </UI.WithIcon>
                </UI.Button>
              </Link>
            </Can>
          </UI.ButtonWrap>
        </UI.PageHeader>

        <UI.CardGroup>
          <Collection resourceName='onboarding.onboarding_checklists'>
            <SelectedDepartmentFilter />
            <UI.TableHeader>
              <Translator name='onboarding.filters'>
                <EnumFilter
                  defaultValue={null}
                  enum='employment_type'
                  allowNull
                  name='employment_type'
                  placeholder='-'
                />
                <SearchFilter />
              </Translator>
            </UI.TableHeader>
            <WhenCollectionIsNotEmpty>
              <OnboardingListView displayChecklists={false} />
            </WhenCollectionIsNotEmpty>
            <PaginationFilter />
          </Collection>

        </UI.CardGroup>
      </Translator>
    </AdminPageWithSmartview>
  )
}
